import { createAction, props } from '@ngrx/store';
import { PHASE_ONE } from '../../../model/phases.model';

export const ADD_PHASE_ONE = createAction(
  'ADD_PHASE_ONE',
  props<{ payload: PHASE_ONE }>()
);

// export const GET_PHASE_ONE_DATA = createAction('GET_PHASE_ONE_DATE');
